<layout-base
	layoutClassName="authenticated-layout"
	[withContactForm]="true"
	[withThemeSelector]="true"
	[themesIsOpened]="themesIsOpened"
	(action)="handleAction($event)">

	<nav id="menu" menu layout-menu>
		<new-federation-steps menu-content [currentStep]="currentStep$ | async"/>
	</nav>

	<header id="top-bar" content-top-bar layout-top-bar
		[withThemeSelector]="true"
		(action)="handleAction($event)">
	</header>

	<div content-main class="col-lg-10">
		<router-outlet></router-outlet>
	</div>
</layout-base>